import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
} from '@mui/material';
import styled from '@mui/system/styled';
import { Theme } from '@mui/material/styles';
import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MANTY_BLACK } from 'styles/theme';

const StyAccordionContainer = styled(Accordion, {
    name: 'StyAccordion',
})<{ color?: keyof Theme['palette']; textColor?: keyof Theme['palette'] }>(
    ({ theme, color, textColor }) => ({
        width: '100%',
        display: 'flex',
        height: 'fit-content',
        flexDirection: 'column',
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        justifyContent: 'space-between',
        alignItems: 'stretch',
        alignSelf: 'stretch',
        '&::before': {
            visibility: 'hidden',
        },
        backgroundColor: color
            ? theme.palette[color].background
            : theme.palette.common.white,
        color: textColor ? theme.palette[textColor].main : MANTY_BLACK,
    }),
);
const StyAccordionSummary = styled(AccordionSummary, {
    name: 'StyAccordionSummary',
})({
    '&.MuiAccordionSummary-root': {
        margin: '0px',
        padding: '0px',
        minHeight: '1rem',
    },
    '& .MuiAccordionSummary-content': {
        margin: '0px',
        '&.Mui-expanded': {
            margin: '0px',
        },
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
        padding: '0px !important',
    },
});

const StyAccordionDetails = styled(AccordionDetails, {
    name: 'StyAccordionDetails',
})({
    padding: '0px',
});
type AccordionProps = {
    dataTestid?: string;
    children: React.ReactNode;
    onChange?: () => void;
    title: string;
    defaultExpanded?: boolean;
    color?: keyof Theme['palette'];
    textColor?: keyof Theme['palette'];
};
const StyAccordion = ({
    dataTestid = undefined,
    children,
    onChange = () => {},
    color = undefined,
    textColor = undefined,
    title,
    defaultExpanded = true,
}: AccordionProps) => {
    return (
        <StyAccordionContainer
            onChange={onChange}
            defaultExpanded={defaultExpanded}
            color={color}
            textColor={textColor}
            data-testid={dataTestid}
        >
            {title && (
                <StyAccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h5">{title}</Typography>
                </StyAccordionSummary>
            )}
            <StyAccordionDetails>{children}</StyAccordionDetails>
        </StyAccordionContainer>
    );
};
export default StyAccordion;
